export const ACCESS_LAB_PREFERENCE_EVENT = 'access-lab-preference-change';

const ACCESS_LAB_ENABLED_KEY = 'access-lab-enabled';

export const ACCESS_LAB_AVAILABLE = Boolean(
  import.meta.env?.DEV ||
  import.meta.env?.MODE === 'test' ||
  (import.meta.env?.VITE_ENABLE_ACCESS_LAB === 'true' && import.meta.env?.MODE !== 'production'),
);

export function readAccessLabEnabled() {
  if (typeof window === 'undefined') return true;
  return window.localStorage.getItem(ACCESS_LAB_ENABLED_KEY) !== 'false';
}

export function writeAccessLabEnabled(enabled) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(ACCESS_LAB_ENABLED_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(ACCESS_LAB_PREFERENCE_EVENT, { detail: { enabled } }));
}
